const messageCategory = {
  BoatDamageClaim: "BoatDamageClaim",
  BuyInsurance: "BuyInsurance",
  CancelInsurance: "CancelInsurance",
  Cancellations: "Cancellations",
  CarDamageClaim: "CarDamageClaim",
  ConstructionDamageClaim: "ConstructionDamageClaim",
  ConstructionLeakageAndFire: "ConstructionLeakageAndFire",
  Estate: "Estate",
  ExistingClaim: "ExistingClaim",
  ForestDamageClaim: "ForestDamageClaim",
  General: "General",
  HealthAssessment: "HealthAssessment",
  InsuranceMatter: "InsuranceMatter",
  Invoicing: "Invoicing",
  LegalClaim: "LegalClaim",
  LiabilityClaim: "LiabilityClaim",
  ManualTask: "ManualTask",
  MotorClaims: "MotorClaims",
  PersonalInjuryClaim: "PersonalInjuryClaim",
  PersonClaims: "PersonClaims",
  PetClaim: "PetClaim",
  PersonalInjuryInTrafficClaim: "PersonalInjuryInTrafficClaim",
  PropertyClaims: "PropertyClaims",
  PropertyLuggageClaim: "PropertyLuggageClaim",
  PropertyDamageClaim: "PropertyDamageClaim",
  Response: "Response",
  TravelClaims: "TravelClaims",
  TravelInjuryClaim: "TravelInjuryClaim",
  TravelInterruptionClaim: "TravelInterruptionClaim",
};

export default messageCategory;
